/**
 * Cercas do cliente.
 *
 * Carregadas uma vez na subida: elas mudam por cadastro, não a cada segundo — e
 * recarregar a cada render poria uma consulta no caminho do mapa ao vivo.
 */
import { create } from "zustand";
import { api } from "../lib/api.ts";
import type { Geofence } from "../lib/schemas.ts";
import { useAuthStore } from "./auth.store.ts";

interface GeofenceState {
  items: Geofence[];
  loaded: boolean;
  load: (token: string, signal?: AbortSignal) => Promise<void>;
  /**
   * Busca de novo, ignorando o `loaded`.
   *
   * O `load` tem guarda porque roda na subida de toda tela; o `reload` existe
   * para o cadastro: quem acabou de desenhar uma cerca tem que vê-la no mapa
   * sem recarregar a página. Sem isto, o mapa mostraria a cerca velha até o
   * próximo F5 — e o operador concluiria que não salvou.
   */
  reload: () => Promise<void>;
}

export const useGeofenceStore = create<GeofenceState>((set, get) => ({
  items: [],
  loaded: false,
  load: async (token, signal) => {
    if (get().loaded) return;
    try {
      const items = await api.geofences(token, signal);
      set({ items, loaded: true });
    } catch {
      // Sem cercas o mapa continua servindo. Falhar aqui não pode tirar do ar a
      // tela que mostra onde a frota está.
      set({ loaded: true });
    }
  },
  reload: async () => {
    const token = useAuthStore.getState().token;
    if (!token) return;
    try {
      set({ items: await api.geofences(token), loaded: true });
    } catch {
      // Mesma razão do `load`: sem cercas o mapa continua servindo.
    }
  },
}));
